<template>
  <b-form-select v-model="localSelected" @change="selectChange" :options="dispensers" />
</template>

<script>
import { Action } from "@/store/actions";
import { mapState } from "vuex";

export default {
  name: "DispenserSelect",
  props: {
    selected: String,
  },
  data() {
    return {
      localSelected: '',
    };
  },
  computed: {
    ...mapState({
      dispensers: state => state.dispenser.dispensersSelect,
    }),
  },
  watch: {
    // If parent sets form.group after mount (async device load), sync it down
    selected(val) {
      if (val !== this.localSelected) {
        this.localSelected = val;
      }
    },
    // Once dispensers load, re-apply the selected value
    dispensers(list) {
      if (list.length > 0) {
        this.applySelected();
      }
    },
  },
  methods: {
    selectChange(val) {
      this.$emit('update:selected', val);
    },
    applySelected() {
      if (this.selected) {
        // Check by value OR text to be safe
        const found = this.dispensers.find(
          d => d.value === this.selected || d.text === this.selected
        );
        if (found) {
          this.localSelected = found.value;
          this.$emit('update:selected', found.value);
          return;
        }
      }
      // No match and nothing selected — don't auto-select first item,
      // just leave blank so user consciously picks one
      this.localSelected = '';
    },
  },
  mounted() {
    this.localSelected = this.selected || '';
    this.$store.dispatch(Action.dispenser.load).then(() => {
      this.applySelected();
    });
  },
};
</script>